<div class="flex items-center gap-6 mt-2 w-fit" data-testid="filter-badge" [class.leaving]="leaving()">
  <span class="text-xs text-shikenso-purple-base-60">
    {{ label() | translate }}
  </span>

  <div
    class="flex items-center gap-2 rounded-full bg-shikenso-pink-base-60 border border-shikenso-purple-base-12"
    [class]="showAvatar() ? 'pl-[3px]' : 'pl-3'"
  >
    @if (showAvatar()) {
      <app-icon-badge
        [content]="avatar()"
        [fallbackText]="name()"
        [size]="20"
        [iconSize]="20"
        [fontSize]="8"
        [borderRadius]="100"
      />
    }
    <span class="text-xs font-medium" data-testid="filter-badge-name">{{ name() }}</span>

    <button
      mat-icon-button
      type="button"
      class="flex items-center justify-center ml-1"
      data-testid="filter-badge-remove"
      (click)="startLeave()"
    >
      <app-icon src="/icons/x-mark.svg" alt="Remove" [size]="12" />
    </button>
  </div>
</div>
